import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/AuthService';
import { k } from 'src/environments/properties';

@Component({
  selector: 'app-login',
  templateUrl: './cambio-contrasena.component.html',
  styleUrls: ['./cambio-contrasena.component.scss'],
})
export class CambioContrasenaComponent implements OnInit {

    public userId:string;    
    userToken:any;
    userName:any;
    firstName:any;
    lastName:any;

    returnUrl = 'auth/login';


    constructor(private authService: AuthService, private router: Router){}
      
      async ngOnInit() { 
        this.userToken =  localStorage.getItem(k.token);        
        if( this.userToken ){
            const dataUser = await this.authService.dataUser( this.userToken  );
            this.userId    = dataUser?.id;
            this.userName  = dataUser?.username;
            this.firstName = dataUser?.firstName;
            this.lastName  = dataUser?.lastName;
        }
      }

      logout(){
        this.authService.logout();
        this.router.navigate([this.returnUrl]);
      }

    
}